import type {ReactElement} from 'react';
import React, {useRef} from 'react';
import {Panel, PanelHeader} from '@Components/panel';
import useDefaultPanelClose from '@Panels/hooks/useDefaultPanelClose';
import {updateOptionsPanelHeight} from '@Components/poster-editor/library/poster-editor-library';
import {SeekbarDurationOptionsContent} from '@Components/poster-editor/components/poster-seekbar/components/seekbar-duration-options-content';
import {SelectorType} from '@Components/poster-editor/components/poster-seekbar/components/change-duration-selector/change-duration-selector.types';

export interface DurationDropdownProps {
  panelId: string;
}

function DurationDropdown({...props}: DurationDropdownProps): ReactElement | null {
  const containerRef = useRef<HTMLDivElement>(null);
  const onClose = useDefaultPanelClose(props.panelId);

  const getTotalDisplayingOptions = (): number => {
    const page = window.posterEditor?.whiteboard?.getCurrentPage();
    let totalOptionsDisplaying = 0;
    if (page?.items.hasVideoItem()) {
      totalOptionsDisplaying += 1;
    }
    if (window.posterEditor?.whiteboard?.audioClips.hasAudio()) {
      totalOptionsDisplaying += 1;
    }
    if (page?.items.hasStreamingSlideShowItem()) {
      totalOptionsDisplaying += 1;
    }

    return totalOptionsDisplaying;
  };

  const updateHeightInRedux = (newType: SelectorType): void => {
    const totalOptionsDisplaying = getTotalDisplayingOptions();
    const heightForIndividualOption = 64;
    let height = 80;

    height += heightForIndividualOption * totalOptionsDisplaying + totalOptionsDisplaying * 8;

    if (newType === SelectorType.CUSTOM) {
      height += 89;
    } else {
      height += heightForIndividualOption;
    }

    updateOptionsPanelHeight(props.panelId, `${height}px`);
  };

  const getHeader = (): ReactElement => {
    return <PanelHeader title="Duration" onClose={onClose} />;
  };

  const getContent = (): ReactElement => {
    return (
      <div className="spacing-p-l-4 spacing-p-r-4">
        <SeekbarDurationOptionsContent onChangeSelectorTypeCallback={updateHeightInRedux} isMobileVersion />
      </div>
    );
  };

  return <Panel ref={containerRef} panelHeader={getHeader()} panelContent={getContent()} />;
}

export default DurationDropdown;
